module.exports = __webpack_public_path__ + "static/media/wonder.48b523bd.jpg";